<div class="inline-buttton-container">
    <label class="label mr-2" for="input-authorityname">{{ controlLabel }}<span *ngIf="required" class="error-message required">*</span></label>
    <button *ngIf="canAddNewEntries" nbButton type="button" status="success" class="sm-button mr-3" (click)="addText()">
        <i class="fa fa-plus"></i>
    </button>
    <button nbButton type="button" status="danger" class="sm-button" (click)="clearAll()">
        <i class="fa fa-trash"></i>
    </button>
</div>
<div class="border mt-1" *ngFor="let textTypeEntry of textTypeEntries; let i = index">
    <div class="row">
        <div class="col col-10 col-lg-11">
            <div class="row" *ngIf="!longText">
                <div class="col col-12 col-md-12 col-lg-6">
                    <div class="form-control-group">
                        <label class="label" for="{{ controlName }}-text-type-entry-text-{{ i }}">Teksts</label>
                        <input
                            nbInput
                            [(ngModel)]="textTypeEntry.text"
                            #textTypeEntryText="ngModel"
                            id="{{ controlName }}-text-type-entry-text-{{ i }}"
                            name="{{ controlName }}-text-type-entry-text-{{ i }}"
                            [placeholder]="controlLabel"
                            fullWidth
                            [maxlength]="longText ? 1000 : 200"
                            [required]="true"
                            [status]="textTypeEntryText.touched ? (textTypeEntryText.invalid ? 'danger' : 'success') : ''"
                            [attr.aria-invalid]="textTypeEntryText.invalid && textTypeEntryText.touched ? true : null"
                            (ngModelChange)="entriesChanged()"
                        />
                        <ng-container *ngIf="textTypeEntryText.invalid && textTypeEntryText.touched">
                            <p class="error-message m-0" *ngIf="textTypeEntryText?.errors?.required">
                                Teksts jānorāda obligāti!
                            </p>
                        </ng-container>
                    </div>
                </div>
                <div class="col col-12 col-md-12 col-lg-6">
                    <div class="form-control-group">
                        <label class="label" for="{{ controlName }}-text-type-entry-lang-{{ i }}">Valoda</label>
                        <nb-select
                            [(ngModel)]="textTypeEntry.languageId"
                            (ngModelChange)="checkRequiredLanguagesUsed()"
                            #textTypeEntryLanguage="ngModel"
                            name="{{ controlName }}-text-type-entry-lang-{{ i }}"
                            fullWidth
                            [status]="textTypeEntryLanguage.touched ? (textTypeEntryLanguage.invalid ? 'danger' : 'success') : 'primary'"
                            [required]="true"
                            placeholder="Valoda"
                            [attr.aria-invalid]="textTypeEntryLanguage.invalid && textTypeEntryLanguage.touched ? true : null"
                            (ngModelChange)="entriesChanged()"
                        >
                            <nb-option *ngFor="let language of getLanguagesForEntry(i)" [value]="language.id">{{ language.description }}</nb-option>
                        </nb-select>
                        <ng-container *ngIf="textTypeEntryLanguage.invalid && textTypeEntryLanguage.touched">
                            <p class="error-message m-0" *ngIf="textTypeEntryLanguage?.errors?.required">
                                Valoda ir jānorāda obligāti!
                            </p>
                        </ng-container>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="longText">
                <div class="form-control-group">
                    <label class="label" for="{{ controlName }}-text-type-entry-text-{{ i }}">Teksts</label>
                    <textarea
                        nbInput
                        [(ngModel)]="textTypeEntry.text"
                        #textTypeEntryText="ngModel"
                        id="{{ controlName }}-text-type-entry-text-{{ i }}"
                        name="{{ controlName }}-text-type-entry-text-{{ i }}"
                        [placeholder]="controlLabel"
                        fullWidth
                        [maxlength]="longText ? 1000 : 200"
                        [required]="true"
                        [status]="textTypeEntryText.touched ? (textTypeEntryText.invalid ? 'danger' : 'success') : ''"
                        [attr.aria-invalid]="textTypeEntryText.invalid && textTypeEntryText.touched ? true : null"
                        (ngModelChange)="entriesChanged()"
                    ></textarea>
                    <ng-container *ngIf="textTypeEntryText.invalid && textTypeEntryText.touched">
                        <p class="error-message m-0" *ngIf="textTypeEntryText?.errors?.required">
                            Teksts jānorāda obligāti!
                        </p>
                    </ng-container>
                </div>

                <div class="form-control-group">
                    <label class="label" for="{{ controlName }}-text-type-entry-lang-{{ i }}">Valoda</label>
                    <nb-select
                        [(ngModel)]="textTypeEntry.languageId"
                        (ngModelChange)="checkRequiredLanguagesUsed()"
                        #textTypeEntryLanguage="ngModel"
                        name="{{ controlName }}-text-type-entry-lang-{{ i }}"
                        fullWidth
                        [status]="textTypeEntryLanguage.touched ? (textTypeEntryLanguage.invalid ? 'danger' : 'success') : 'primary'"
                        [required]="true"
                        placeholder="Valoda"
                        [attr.aria-invalid]="textTypeEntryLanguage.invalid && textTypeEntryLanguage.touched ? true : null"
                        (ngModelChange)="entriesChanged()"
                    >
                        <nb-option *ngFor="let language of getLanguagesForEntry(i)" [value]="language.id">{{ language.description }}</nb-option>
                    </nb-select>
                    <ng-container *ngIf="textTypeEntryLanguage.invalid && textTypeEntryLanguage.touched">
                        <p class="error-message m-0" *ngIf="textTypeEntryLanguage?.errors?.required">
                            Valoda ir jānorāda obligāti!
                        </p>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div class="col col-2 col-md-2 col-lg-1 align-items-center justify-content-center" *ngIf="!entryHasRequiredLanguage(textTypeEntry)">
            <button nbButton type="button" status="danger" class="sm-button mt-3" (click)="removeText(i)">
                <i class="fa fa-minus"></i>
            </button>
        </div>
    </div>
</div>
